import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Reveal } from "../components/Reveal";
import OrderPipeline from "../components/OrderPipeline";

export default function Account() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (user === false) { navigate("/auth"); return; }
    if (user) api.get("/orders/mine").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  }, [user, navigate]);

  if (!user) return null;

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-12 pt-32 pb-16" data-testid="account-page">
      <Reveal>
        <p className="eyebrow mb-3">Account</p>
        <h1 className="font-display text-4xl md:text-5xl uppercase tracking-tight" data-testid="account-greeting">
          Yo, {user.name?.split(" ")[0] || "friend"}
        </h1>
        <p className="font-mono text-xs uppercase tracking-widest text-zinc-500 mt-3">{user.email}</p>
      </Reveal>

      <div className="mt-12 space-y-6">
        {orders === null && <p className="font-mono text-xs uppercase tracking-widest text-zinc-500" data-testid="orders-loading">Loading orders…</p>}
        {orders?.length === 0 && (
          <div className="border border-white/10 bg-card p-10 text-center" data-testid="orders-empty">
            <p className="font-mono text-xs uppercase tracking-widest text-zinc-500">No orders yet. Fix that.</p>
            <button onClick={() => navigate("/shop")} className="btn-kinetic mt-6" data-testid="account-shop-button">Shop the drop</button>
          </div>
        )}
        {orders?.map((o) => (
          <Reveal key={o.order_number}>
            <div className="border border-white/10 bg-card p-6" data-testid={`account-order-${o.order_number}`}>
              <div className="flex flex-wrap justify-between gap-3 mb-6">
                <div>
                  <p className="font-display text-xl uppercase text-kinetic">{o.order_number}</p>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500 mt-1">{new Date(o.created_at).toLocaleDateString()}</p>
                </div>
                <div className="text-right font-mono text-xs uppercase tracking-widest">
                  <p className={o.payment_status === "paid" ? "text-emerald-500" : "text-amber-500"}>{o.payment_status.replace("_", " ")}</p>
                  <p className="text-zinc-300 mt-1">${o.total.toFixed(2)}</p>
                </div>
              </div>
              <OrderPipeline status={o.status} />
              <div className="mt-6 flex flex-wrap gap-3">
                {o.items.map((i, idx) => (
                  <div key={idx} className="flex items-center gap-2 border border-white/10 px-3 py-2">
                    <img src={i.image} alt="" className="w-8 h-10 object-cover" />
                    <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-400">{i.name} · {i.size} × {i.qty}</span>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
